import { create } from 'zustand';

const chatStore = create((set) => ({
    newMessageRecieved: null,
    newMessageReactionRecieved: null,
    newChatPermissionRecieved: null,
    newChatNotificationRecieved: null,
    unreadChatCounts: {},
    notificationPermissionList: [],
    liveUserCounts : {},
    setUnreadChatCounts: (updater) =>
    set((state) => ({
      unreadChatCounts:
        typeof updater === 'function'
          ? updater(state.unreadChatCounts)
          : updater,
    })),
    setNewMessageRecieved: (message) => set({ newMessageRecieved: message }),
    setNewMessageReactionRecieved: (message) => set({ newMessageReactionRecieved: message }),
    setNewChatPermissionRecieved: (message) => set({ newChatPermissionRecieved: message }),
    setNewChatNotificationRecieved: (message) => set({ newChatNotificationRecieved: message }),
    setNotificationPermissionList: (message) => set({ notificationPermissionList: message }),
    setLiveUserCounts: (data) => set({ liveUserCounts: data }),

    // Reset everything back to defaults
    resetChat: () =>
      set({
        newMessageRecieved: null,
        newMessageReactionRecieved: null,
        newChatPermissionRecieved: null,
        newChatNotificationRecieved: null,
        unreadChatCounts: {},
        notificationPermissionList: [],
        liveUserCounts: {},
      }),
}));

export default chatStore;
